export default __webpack_public_path__ + "static/media/tunnel_slalom.063192ca.jpg";